<template>
	<div>
		<div class="tw-text-3xl tw-font-bold" v-if="!isDone">
			{{ $t('integrations.connection-noon-store-title') }}
		</div>
		<div class="tw-flex tw-items-center tw-gap-2" v-else>
			<div class="tw-text-3xl tw-font-bold">
				{{ $t('integrations.your-store-connected') }}
			</div>
			<div
				class="'tw-border-secondary-500 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-bg-secondary-500 tw-text-white"
				style="width: 32px; height: 32px"
			>
				<AppIcon name="check" />
			</div>
		</div>
		<div class="tw-font-medium tw-text-gray-500">
			{{ $t('integrations.connection-noon-store-description') }}
		</div>

		<div class="tw-mt-3 tw-flex tw-flex-col tw-gap-4" style="width: 70%">
			<div class="tw-border-b tw-border-b-gray-300 tw-pb-4">
				<div class="tw-flex tw-items-center">
					<span>1. {{ $t('integrations.visit-noon-seller-lab') }}</span>
					<a
						class="tw-cursor-pointer tw-ps-1 tw-text-blue-500 tw-underline hover:tw-underline"
						href="https://catalog.noon.partners/en-ae/ftp"
						target="_blank"
						>{{ $t('integrations.here') }}</a
					>
				</div>
			</div>
			<div class="tw-border-b tw-border-b-gray-300 tw-pb-4">
				<div class="tw-flex tw-flex-col tw-gap-0.5">
					<div>2. {{ $t('integrations.after-logging-into-account-you-should-find') }}</div>
					<AppImage
						:src="loadFile('assets/v2/image/noon-integration/noon-help-configure-1.png')"
						width="100%"
						class="tw-rounded-lg"
					/>
				</div>
			</div>

			<div class="tw-border-b tw-border-b-gray-300 tw-pb-4">
				<div class="gap-1 tw-flex tw-flex-col">
					<div>3. {{ $t('integrations.copy-details-from-fields-and-paste-into-ftp') }}</div>
					<div class="tw-grid tw-grid-cols-3 tw-gap-2">
						<div class="tw-col-span-3 lg:tw-col-span-1">
							<AppInput
								v-model="form.protocol"
								:label="$t('integrations.protocol')"
								disabled
								size="sm"
							/>
						</div>
						<div class="tw-col-span-3 lg:tw-col-span-1">
							<AppInput
								v-model="form.host"
								:label="$t('integrations.host')"
								disabled
								size="sm"
							>
								<template #end-btn>
									<AppButton
										startIcon="assets/v2/image/icons/copy.svg"
										tertiary
										variant="gray"
										square
										size="lg"
										@click="copy(form.host)"
									/>
								</template>
							</AppInput>
						</div>
						<div class="tw-col-span-3 lg:tw-col-span-1">
							<AppInput
								v-model="form.port"
								:label="$t('integrations.port')"
								disabled
								size="sm"
							>
								<template #end-btn>
									<AppButton
										startIcon="assets/v2/image/icons/copy.svg"
										tertiary
										variant="gray"
										square
										size="lg"
										@click="copy(form.port)"
									/>
								</template>
							</AppInput>
						</div>
						<div class="tw-col-span-3 lg:tw-col-span-1">
							<AppInput
								v-model="form.connection_name"
								:label="$t('integrations.connection-name')"
								disabled
								size="sm"
							>
								<template #end-btn>
									<AppButton
										startIcon="assets/v2/image/icons/copy.svg"
										tertiary
										variant="gray"
										square
										size="lg"
										@click="copy(form.connection_name)"
									/>
								</template>
							</AppInput>
						</div>
						<div class="tw-col-span-3 lg:tw-col-span-1">
							<AppInput
								v-model="form.username"
								:label="$t('integrations.username')"
								disabled
								size="sm"
							>
								<template #end-btn>
									<AppButton
										startIcon="assets/v2/image/icons/copy.svg"
										tertiary
										variant="gray"
										square
										size="lg"
										@click="copy(form.username)"
									/>
								</template>
							</AppInput>
						</div>
						<div class="tw-col-span-3 lg:tw-col-span-1">
							<AppInput
								v-model="form.password"
								:label="$t('integrations.password')"
								disabled
								size="sm"
							>
								<template #end-btn>
									<AppButton
										startIcon="assets/v2/image/icons/copy.svg"
										tertiary
										variant="gray"
										square
										size="lg"
										@click="copy(form.password)"
									/>
								</template>
							</AppInput>
						</div>
					</div>
					<AppImage
						:src="loadFile('assets/v2/image/noon-integration/noon-help-configure-2.png')"
						width="100%"
						class="tw-mt-0.5 tw-rounded-lg"
					/>
				</div>
			</div>

			<div class="tw-border-b tw-border-b-gray-300 tw-pb-4">
				<div class="tw-flex tw-items-center">
					<span>4. {{ $t('integrations.make-sure-that-details-are-matching') }}</span>
					<span class="tw-ps-0.5 tw-text-brand-500">Update your FTP Details button.</span>
				</div>
			</div>

			<div class="tw-border-b tw-border-b-gray-300 tw-pb-4">
				<div class="tw-flex tw-flex-col tw-gap-0.5">
					<div>5. {{ $t('integrations.scroll-down-into-the-import-jobs') }}</div>
					<AppImage
						:src="loadFile('assets/v2/image/noon-integration/noon-help-configure-3.png')"
						width="100%"
						class="tw-rounded-lg"
					/>
				</div>
			</div>

			<div class="tw-border-b tw-border-b-gray-300 tw-pb-4">
				<div class="gap-1 tw-flex tw-flex-col">
					<div>
						6.
						{{ $t('integrations.copy-details-from-fields-and-paste-into-psku-price-update') }}
					</div>

					<div>
						<div class="tw-mb-0.5 tw-font-medium">
							{{ $t('integrations.psku-price-update') }}
						</div>
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-3">
							<div class="tw-flex-1">
								<AppInput
									v-model="form.psku_incoming"
									:label="$t('integrations.path-for-incoming-file')"
									disabled
									size="sm"
								>
									<template #end-btn>
										<AppButton
											startIcon="assets/v2/image/icons/copy.svg"
											tertiary
											variant="gray"
											square
											size="lg"
											@click="copy(form.psku_incoming)"
										/>
									</template>
								</AppInput>
							</div>
							<div class="tw-flex-1">
								<AppInput
									v-model="form.psku_pull"
									:label="$t('integrations.noon-should-pull-file')"
									disabled
									size="sm"
								/>
							</div>
						</div>
					</div>
					<div>
						<div class="tw-my-0.5 tw-font-medium">
							{{ $t('integrations.cross-dock-stock-update') }}
						</div>
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-3">
							<div class="tw-flex-1">
								<AppInput
									v-model="form.cross_incoming"
									:label="$t('integrations.path-for-incoming-file')"
									disabled
									size="sm"
								>
									<template #end-btn>
										<AppButton
											startIcon="assets/v2/image/icons/copy.svg"
											tertiary
											variant="gray"
											square
											size="lg"
											@click="copy(form.cross_incoming)"
										/>
									</template>
								</AppInput>
							</div>
							<div class="tw-flex-1">
								<AppInput
									v-model="form.cross_pull"
									:label="$t('integrations.noon-should-pull-file')"
									disabled
									size="sm"
								/>
							</div>
						</div>
					</div>

					<AppImage
						:src="loadFile('assets/v2/image/noon-integration/noon-help-configure-4.png')"
						width="100%"
						class="tw-mt-0.5 tw-rounded-lg"
					/>
				</div>
			</div>

			<div class="tw-border-b tw-border-b-gray-300 tw-pb-4">
				<div class="tw-flex tw-flex-col">
					<div>7. {{ $t('integrations.click-test-connections-and-launch') }}</div>
					<AppImage
						:src="loadFile('assets/v2/image/noon-integration/noon-help-configure-5.png')"
						width="100%"
						class="tw-rounded-lg"
					/>
				</div>
			</div>

			<div class="tw-border-b tw-border-b-gray-300 tw-pb-4">
				<div class="tw-flex tw-flex-col">
					<div>8. {{ $t('integrations.click-complete-connection-below') }}</div>
				</div>
			</div>

			<div class="tw-mt-5">
				<AppButton
					:label="$t('integrations.complete-connection')"
					size="xl"
					class="tw-rounded-full"
					endIcon="assets/v2/image/icons/check.svg"
					type="button"
					style="width: 250px"
					:disabled="nextStepLoading"
					@click="nextStep"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { ref, computed, onMounted } from 'vue';
import { marketplaceStepStatusEnum } from '../../helper';
import { Marketplace } from '../../../../entities/marketplace';
import { loadFile } from '@/v2/utils/index';
import { Clipboard } from 'v-clipboard';

const linkMarketplaceStore = useLinkMarketplaceStore();

const isDone = ref(
	linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.Complete,
);
const nextStepLoading = ref(false);

const form = ref({
	protocol: 'SFTP',
	host: '192.168.1.1',
	port: '7389',
	connection_name: 'Linker',
	username: 'Seller_NLSD',
	password: 'SFSF@2gds2',
	psku_incoming: '/storage/import/price',
	psku_pull: 'Every 30 minutes',
	cross_incoming: '/storage/import/stock',
	cross_pull: 'Every 30 minutes',
});

const copy = (text) => {
	Clipboard.copy(text);
};

const nextStep = async () => {
	nextStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
		isDone.value = true;
	} finally {
		nextStepLoading.value = false;
	}
};

onMounted(async () => {
	const data = await Marketplace.getNoonSftpDetails(linkMarketplaceStore.linkedMarketplaceId);
	form.value.host = data.sftp_host;
	form.value.port = data.sftp_port;
	form.value.password = data.sftp_password;
	form.value.username = data.sftp_username;
});
</script>

<style lang="scss" scoped></style>
